import { initContract } from '@ts-rest/core';
import { z } from 'zod';

import { getBusinessCardResponseSchema, powerOfAttorneyResponseSchema, vatRepresentationResponseSchema } from './schemas';

const c = initContract();

export const declarantWalletContract = c.router({
  getBusinessCard: {
    method: 'GET',
    path: '/businessCard/:declarantId',
    pathParams: z.object({ declarantId: z.string() }),
    responses: {
      200: getBusinessCardResponseSchema,
    },
  },
  receiveBusinessCardProof: {
    method: 'POST',
    path: '/BusinessCard/:declarantId/:sellerWallet',
    pathParams: z.object({ declarantId: z.string(), sellerWallet: z.string() }),
    body: z.union([
      z.object({
        format: z.string(),
        credential: z.object({ credential: z.string() }),
        c_nonce: z.string(),
        c_nonce_expires_in: z.number(),
      }),
      z.object({
        format: z.string(),
        credential: z.string(),
        c_nonce: z.string(),
        c_nonce_expires_in: z.number(),
      }),
    ]),
    responses: {
      200: z.object({ message: z.string() }),
    },
  },
  getPowerOfAttorney: {
    method: 'GET',
    path: '/PowerOfAttorney/:declarantId/:importerId',
    pathParams: z.object({ declarantId: z.string(), importerId: z.string() }),
    responses: {
      200: powerOfAttorneyResponseSchema,
    },
  },
  getVATRepresentation: {
    method: 'GET',
    path: '/VATRepresentation/:declarantId/:importerId',
    pathParams: z.object({ declarantId: z.string(), importerId: z.string() }),
    responses: {
      200: vatRepresentationResponseSchema,
    },
  },
  getApiCredentials: {
    method: 'GET',
    path: '/ApiCredentials/:declarantId/:forwarderId',
    pathParams: z.object({ declarantId: z.string(), forwarderId: z.string() }),
    responses: {
      200: z.object({
        email: z.string(),
        password: z.string().optional().nullable(),
        url: z.string(),
      }),
    },
  },
  retrieveApiCredentials: {
    method: 'POST',
    path: '/ApiCredentials/:declarantId/:brokerWallet',
    pathParams: z.object({ declarantId: z.string(), brokerWallet: z.string() }),
    body: z.object({ credential: z.string() }),
    responses: {
      200: z.object({ message: z.string() }),
    },
  },
  getProofPresentation: {
    method: 'GET',
    path: '/ProofPresentation/:declarantId/:shipmentId',
    pathParams: z.object({ declarantId: z.string(), shipmentId: z.string() }),
    responses: {
      200: z.object({ proof: z.string() }),
    },
  },
});
